export default {
  id: 178,
  title: 'Target #178 - Candy',
  url: 'https://cssbattle.dev/play/178',
  colors: ['#CBE8DD', '#007192'],
  solution:
    '<p a><p b><p c><style>body,p[c]{background:#cbe8dd}p{position:fixed}p[a]{top:94;left:70;width:200;height:20;border:30px solid;border-color:#cbe8dd #007192}p[b]{top:84;left:110;width:180;height:100;background:#007192;border-radius:10px}p[c]{top:0;left:155;width:10;height:270;transform:rotate(20deg);box-shadow:18px 0 #cbe8dd,37px 0 #cbe8dd,56px 0 #cbe8dd,75px 0 #cbe8dd}</style>',
}
